import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import application from './modules/application'
import booking from './modules/booking'
import campground from './modules/campground'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

let hasSessionStorage = true
try {
  window.sessionStorage
} catch (e) {
  hasSessionStorage = false
}

// Version check - clear old state
const APP_VERSION = process.env.git.COMMITHASH || 'unknown'
const STORED_VERSION_KEY = 'app-version'

if (hasSessionStorage) {
  try {
    const storedVersion = sessionStorage.getItem(STORED_VERSION_KEY)
    if (storedVersion !== APP_VERSION) {
      console.log(`App version changed from ${storedVersion} to ${APP_VERSION}, clearing sessionStorage`)
      // Keep only cookie consent
      const cookieAccepted = sessionStorage.getItem('cookie:accepted')
      sessionStorage.clear()
      if (cookieAccepted) {
        sessionStorage.setItem('cookie:accepted', cookieAccepted)
      }
      sessionStorage.setItem(STORED_VERSION_KEY, APP_VERSION)
    }
  } catch (e) {
    console.error('SessionStorage version check failed:', e)
  }
}

let plugins = []
if (hasSessionStorage) {
  plugins = [createPersistedState({ storage: window.sessionStorage })]
}

export default new Vuex.Store({
  modules: {
    application,
    booking,
    campground,
  },
  strict: debug,
  plugins: plugins,
})
